import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/jobform/$id')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/settings/appointment-forms/$id/edit',
      params: { id: params.id },
      replace: true,
    });
  },
  component: () => null,
});
